<template>
    <form-row title="Total Building Rentable Square Footage">
        <div class="flex flex-1 justify-between -mt-4">
            <div class="w-56">
                <input-number
                    name="square_feet"
                    v-model="square_feet"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        read_only: { default: false },
    },

    computed: {
        square_feet: {
            get() {
                return store.state.square_feet || null;
            },
            set(val) {
                store.state.square_feet = val;
            },
        },
    },
}
</script>
